"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePopoverStyles = exports.rootVars = exports.popoverVars = exports.popoverCommon = void 0;
var _constants = require("../../components/constants");
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _getRgbaFromHex = _interopRequireDefault(require("../../utils/getRgbaFromHex"));
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var popoverCommon = exports.popoverCommon = ["padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "border", "borderWidth", "borderColor", "borderStyle", "borderRadius"];
var popoverVars = exports.popoverVars = (0, _initVars.default)({
  applied: popoverCommon,
  variables: [{
    key: "maxHeight"
  }]
});
var rootVars = exports.rootVars = (0, _initVars.default)({
  variables: [{
    key: "background",
    canHaveColor: true
  }]
});
var styles = function styles(theme) {
  return {
    rootVariables: rootVars.styles,
    variables: popoverVars.styles,
    root: {
      display: "flex",
      flexDirection: "column",
      minHeight: theme.spacing.base * 8,
      maxWidth: theme.spacing.base * 64,
      position: "absolute",
      top: 0,
      // eslint-disable-next-line @atg/css-rtl-support
      left: 0,
      willChange: "opacity, transform",
      boxSizing: "border-box",
      zIndex: _constants.Z_INDEX.Popover,
      margin: [0, theme.spacing.base],
      "--background": theme.colors.baseContrast020
    },
    rootOpen: {
      animation: "150ms linear normal forwards $rootOpen"
    },
    rootOpenBottom: {
      animation: "150ms linear normal forwards $rootOpenBottom"
    },
    rootClose: {
      animation: "150ms linear normal forwards $rootClose"
    },
    rootCloseTop: {
      animation: "150ms linear normal forwards $rootCloseTop"
    },
    simpleOpen: {
      animation: "0ms linear normal forwards $rootOpen"
    },
    simpleClose: {
      animation: "0ms linear normal forwards $rootClose"
    },
    triangle: {
      boxSizing: "border-box",
      borderWidth: 12,
      borderColor: "transparent",
      borderStyle: "solid",
      zIndex: 2
    },
    topTriangle: {
      borderBottomColor: rootVars.get("background"),
      borderTopWidth: 0,
      borderBottomWidth: 11
    },
    bottomTriangle: {
      borderTopColor: rootVars.get("background"),
      borderBottomWidth: 0,
      borderTopWidth: 11
    },
    content: {
      padding: theme.spacing.base * 2,
      background: rootVars.get("background"),
      borderRadius: 2,
      boxShadow: "-3px -1px 10px 0 ".concat((0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.2)),
      color: theme.colors.baseContrast070,
      overflowY: "auto",
      maxHeight: popoverVars.get("maxHeight")
    },
    overlay: {
      height: "100%",
      width: "100vw",
      position: "fixed",
      top: 0,
      // eslint-disable-next-line @atg/css-rtl-support
      left: 0,
      zIndex: _constants.Z_INDEX.PopoverOverlay,
      opacity: 0
    },
    scroll: {
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": {
        width: theme.spacing.base * 2
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.colors.baseContrast030,
        borderRadius: 2,
        border: "solid ".concat(theme.spacing.base / 2, "px ").concat(theme.colors.baseContrast020)
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: theme.colors.baseContrast040
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: theme.colors.baseContrast020,
        borderRadius: 2,
        marginTop: theme.spacing.base / 2,
        marginBottom: theme.spacing.base / 2
      }
    },
    "@keyframes rootOpen": {
      "0%": {
        opacity: 0,
        transform: "translateY(".concat(theme.spacing.base * 4, "px)")
      },
      "100%": {
        opacity: 1,
        transform: "translateY(0)"
      }
    },
    "@keyframes rootOpenBottom": {
      "0%": {
        opacity: 0,
        transform: "translateY(-".concat(theme.spacing.base * 4, "px)")
      },
      "100%": {
        opacity: 1,
        transform: "translateY(0)"
      }
    },
    "@keyframes rootClose": {
      "0%": {
        opacity: 1,
        transform: "translateY(0px)"
      },
      "100%": {
        opacity: 0,
        transform: "translateY(".concat(theme.spacing.base * 4, "px)")
      }
    },
    "@keyframes rootCloseTop": {
      "0%": {
        opacity: 1,
        transform: "translateY(0px)"
      },
      "100%": {
        opacity: 0,
        transform: "translateY(".concat(-theme.spacing.base * 4, "px)")
      }
    },
    "@keyframes simpleOpen": {
      "0%": {
        opacity: 0
      },
      "100%": {
        opacity: 1
      }
    },
    "@keyframes simpleClose": {
      "0%": {
        opacity: 1
      },
      "100%": {
        opacity: 0
      }
    }
  };
};
var usePopoverStyles = exports.usePopoverStyles = (0, _createUseStyles.default)(styles, {
  name: "Popover"
});